import {
  FilterChip,
  FilterViewerComponentProps,
} from '@spotify/confidence-core-react';
import { EntityFragment } from '@spotify/confidence-graphql';

import { useEntities } from '../../hooks';

export const EntityFilterViewer = (
  props: FilterViewerComponentProps<string[]>,
) => {
  const { value } = props;
  const { entities, hasNextPage, nextPage, isLoading } = useEntities();

  const entityNames = (entities ?? [])
    .filter((entity: EntityFragment) => value?.includes(entity.name))
    .map((e: EntityFragment) => e.displayName);

  if (entityNames.length !== props.value.length && hasNextPage) {
    nextPage();
  }

  const getLabel = () => {
    if (value.length > 1) return `Entities (${value.length})`;
    if (value.length === 1) return `Entity: ${entityNames[0]}`;
    return 'No entities';
  };

  const label = getLabel();

  return <FilterChip {...props} label={label} loading={isLoading} />;
};
